import { render, staticRenderFns } from "./BaseTooltip.vue?vue&type=template&id=638c2d97"
import script from "./BaseTooltip.vue?vue&type=script&lang=js"
export * from "./BaseTooltip.vue?vue&type=script&lang=js"
import style0 from "./BaseTooltip.vue?vue&type=style&index=0&id=638c2d97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports